// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96c052c5","322":"1f1fb54e","461":"154bc8a5","509":"9874e5be"}[chunkId] + ".chunk.js";
};